import { SearchIcon } from 'assets/icons'
import { t } from 'i18next'
import SearchPopup, { SEARCH_MODE } from './popups/searchItems/SearchPopup'
import GroupcalTooltip from './tooltips/GroupcalTooltip'
import { useState } from 'react'
import { CircleIconButton } from './styled'
import { useAppMode } from './providers/AppModeProvider'
import { useTheme } from '@mui/material'

export interface SearchEventsPopupProps {
  mode: SEARCH_MODE
  groupId?: string
  textfieldPlaceholder?: string

  spanId?: string
}

export default function SearchPopupButton(props: SearchEventsPopupProps) {
  const [searchState, setSearchState] = useState(false)
  const theme = useTheme()
  const showSearch = () => {
    setSearchState(true)
  }

  const appMode = useAppMode()

  return (
    <SearchPopup
      groupId={props.groupId}
      mode={props.mode}
      open={searchState}
      setOpen={setSearchState}
      textfieldPlaceholder={props.textfieldPlaceholder}
    >
      <span id={props.spanId} onClick={showSearch}>
        <GroupcalTooltip title={t('search')}>
          <CircleIconButton
            isCondensedWidth={appMode.isCondensedWidth}
            isIconMode={appMode.isCondensedWidth || appMode.isCondensedHeight}
            sx={{
              width: '52px',
              height: '52px',
              marginLeft: 0,
              marginRight: 0,

              boxShadow: 'none',
              border:
                theme.palette.mode === 'dark' ? undefined : '1px solid #E4E4E4',
              background:
                appMode.isCondensedWidth || appMode.isCondensedHeight
                  ? 'transparent'
                  : undefined
            }}
          >
            <SearchIcon
              color={theme.palette.text.primary}
              width={20}
              height={20}
            />
          </CircleIconButton>
        </GroupcalTooltip>
      </span>
    </SearchPopup>
  )
}
